import { pdfYFromTop } from '@src/modules/platform/pdf/pdfYFromTop.ts';

/** FO-GESR reposición template geometry (landscape letter: 1008×612 pt). */
export const REPOSICION_PDF_PAGE = { width: 1008, height: 612 } as const;

export const REPOSICION_PDF_TEMPLATE_PAGE = {
  datos: 0,
  acudiente: 1,
} as const;

export function reposicionPdfYFromTop(yMax: number): number {
  return pdfYFromTop(REPOSICION_PDF_PAGE.height, yMax);
}

/** Value cell interior of the FO-GESR table (label ends ~500pt, right border ~745pt). */
const VALUE_X = 536;
const VALUE_WIDTH = 205;
const FONT_SIZE = 8;
/** pdftotext yMax is the label glyph-box bottom; its baseline sits ~1 descent above. */
const BASELINE_LIFT = 2;

export type ReposicionPdfRect = { x: number; y: number; width: number; height: number };

/** Image box from a top-down band: top edge yTop, given size, converted to pdf-lib. */
function imgBox(x: number, yTop: number, width: number, height: number): ReposicionPdfRect {
  return { x, y: REPOSICION_PDF_PAGE.height - yTop - height, width, height };
}

type ReposicionPdfField = { key: string; yMax: number; maxWidth?: number };

function field(key: string, yMax: number, maxWidth = VALUE_WIDTH): ReposicionPdfField {
  return { key, yMax, maxWidth };
}

export const REPOSICION_PDF_PAGE1_FIELDS: ReposicionPdfField[] = [
  field('idReposicion', 184.84172),
  field('fecha', 202.60172),
  field('documentoBeneficiario', 220.27172),
  field('nombreBeneficiario', 238.03172),
  field('comuna', 255.79172),
  field('direccion', 273.43172),
  field('productosAReponer', 291.19172),
  field('cantidadPanela', 308.95172, 80),
  field('cantidadCocoa', 326.71172, 80),
  field('cantidadAtun', 344.37172, 80),
  field('cantidadHuevos', 362.13172, 80),
  field('cantidadArroz', 379.89172, 80),
  field('cantidadHarinaArepas', 397.53172, 80),
  field('cantidadGalletasSoda', 415.29172, 80),
  field('cantidadPastaSopa', 433.05172, 80),
  field('cantidadEspaguetis', 450.69172, 80),
  field('cantidadAvena', 468.45172, 80),
  field('cantidadAceite', 486.24172, 80),
  field('cantidadLechePolvo', 504.00172, 80),
  field('cantidadFrijol', 521.63772, 80),
  field('cantidadLenteja', 539.39772, 80),
  field('cantidadGarbanzo', 557.15772, 80),
  field('cantidadSal', 574.79772, 80),
  field('medioReporte', 592.55772),
];

export const REPOSICION_PDF_PAGE2_FIELDS: ReposicionPdfField[] = [
  field('otroMedioReporte', 146.56172),
  field('motivoReposicion', 164.20172),
  field('otroMotivoReposicion', 181.96172),
  field('recibeOtraPersona', 199.72172, 120),
  field('parentesco', 217.51172),
  field('documentoAcudiente', 235.15172),
  field('nombreRecibe', 252.91172),
  field('responsableReposicion', 306.07172),
];

/** Record id drawn after the "Documento electrónico" footer (ends x≈112.5, baseline yMax≈335.7). */
export const REPOSICION_PDF_DOC_ID = { x: 118, y: reposicionPdfYFromTop(335.69528) + BASELINE_LIFT } as const;
export const REPOSICION_PDF_DOC_ID_SIZE = 7;

/** Firma de quien recibe: value cell of its ~17.6pt row band (top-down 258–273). */
export const REPOSICION_PDF_FIRMA_BOX: ReposicionPdfRect = imgBox(VALUE_X, 258, VALUE_WIDTH, 15);
/** Registro fotográfico: value cell of the next row band (top-down 275–291). */
export const REPOSICION_PDF_FOTO_BOX: ReposicionPdfRect = imgBox(VALUE_X, 275, VALUE_WIDTH, 16);

export function reposicionPdfFieldPositions(fields: ReposicionPdfField[]): {
  key: string;
  x: number;
  y: number;
  maxWidth: number;
}[] {
  return fields.map((f) => ({
    key: f.key,
    x: VALUE_X,
    y: reposicionPdfYFromTop(f.yMax) + BASELINE_LIFT,
    maxWidth: f.maxWidth ?? VALUE_WIDTH,
  }));
}

export const REPOSICION_PDF_PAGE1_POSITIONS = reposicionPdfFieldPositions(REPOSICION_PDF_PAGE1_FIELDS);
export const REPOSICION_PDF_PAGE2_POSITIONS = reposicionPdfFieldPositions(REPOSICION_PDF_PAGE2_FIELDS);

export const REPOSICION_PDF_FONT_SIZE = FONT_SIZE;
